export default { sha: '7d844654333336a9414396e138fbd7cc056cf29f', buildNumber: 'undefined' }
